'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ClientServiceCtrl
 * @description
 * # ClientCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.services')
  .factory('Client', ['$http', 'domain', 'BaseService', 'toaster', function ($http, domain, BaseService, toaster) {
    var BASE_CLIENT_URL = domain.name + '/api/v1/clients/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_CLIENT_URL,
      baseModelName: 'client'
    });

    baseService.next_client_code = function() {
      return $http.get(domain.name + '/api/v1/clients/next_client_code');
    };

    baseService.error = function(error) {
      if(error && error.status === 422) {
        if('name' in error.data.errors) {
          toaster.pop('error', 'Nombre', 'El nombre ' + error.data.errors.name);
        }
        if('client_code' in error.data.errors) {
          // jscs:disable
          toaster.pop('error', 'Código de cliente',  'El código de cliente ' + error.data.errors.client_code);
          error.data.errors = delete error.data.errors.client_code;
          // jscs:enable
        }
        if('drive_root_id' in error.data.errors) {
          toaster.pop('error', 'Ruta de Google', 'Favor de selecionar una ruta para el cliente');
          error.data.errors = delete error.data.errors.drive_root_id;
        }
        if('url' in error.data.errors) {
          toaster.pop('error', 'Url', 'Favor de verificar la ruta del proyecto.');
          error.data.errors = delete error.data.errors.url;
        }
      }
      baseService.baseError(error);
    };

    return baseService;
  }]);
